import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { theme } from '../../themes/theme'
import { BoldSmallBodyText } from '../styles/Text'

const text = {
  sent: 'Signing',
  completed: 'Completed',
  new: 'Send Failed',
  uploaded: 'Send Failed',
  draft: 'Send Failed',
  send_failed: 'Send Failed'
}

const bgColor = {
  sent: 'rgba(208, 198, 16, 0.1)',
  completed: 'rgba(16, 192, 208, 0.1)',
  new: 'rgba(232, 85, 103, 0.1)',
  uploaded: 'rgba(232, 85, 103, 0.1)',
  draft: 'rgba(232, 85, 103, 0.1)',
  send_failed: 'rgba(232, 85, 103, 0.1)'
}

const borderColor = {
  sent: 'rgba(208, 198, 16, 1)',
  completed: 'rgba(16, 192, 208, 1)',
  new: 'rgba(232, 85, 103, 1)',
  uploaded: 'rgba(232, 85, 103, 1)',
  draft: 'rgba(232, 85, 103, 1)',
  send_failed: 'rgba(232, 85, 103, 1)'
}

const Background = styled.div`
  display: flex;
  white-space: nowrap;

  color: #333;
  border: ${props => `1px solid ${borderColor[props.status]}`};
  background-color: ${props => bgColor[props.status]};
  border-radius: ${theme.borderRadius.button};
  padding: 5px 12px;
`

const WhiteBackground = styled(Background)`
  padding: 0;
  background-color: #fff;
`

const SignatureStatus = ({ status }) => (
  <WhiteBackground>
    <Background status={status.toLowerCase()}>
      <BoldSmallBodyText>{text[status.toLowerCase()]}</BoldSmallBodyText>
    </Background>
  </WhiteBackground>
)

SignatureStatus.propTypes = {
  status: PropTypes.oneOf(['SENT', 'COMPLETED', 'NEW', 'UPLOADED', 'DRAFT', 'SEND_FAILED']).isRequired
}

export default SignatureStatus
